<template>
    <div style="position: relative;">

        <div class="topic-title-box df">

            <span class="hot-title mic-semblod fn">{{ $t('热门话题') }}</span>
            <swiper :options="swiperOption2" ref="topthumbsSwiper">

                <swiper-slide v-for="(item, index) in tablist" :key="index">
                    <span :class="{ 'active': thumbsindex == index }" @click="onSlideClick(index)">
                        {{ item.tt_title }}
                    </span>
                </swiper-slide>

            </swiper>
        </div>

        <!-- 遮罩层 -->
        <div class="left-cloud"></div>
        <div class="right-cloud"></div>

        <swiper :options="swiperOption3" class="topic-list" ref="thumbsSwiper">

            <swiper-slide v-for="(item, index) in allData" :key="index">
                <div class="t1 df jcsb aic">
                    <span class="mic-semblod">{{ item.tt_title }}</span>
                    <el-button type="primary" class="red-btn" @click="onArticle(item.tt_id)">+{{$t('文章投稿')}}</el-button>
                </div>
                <div class="list-box">


                    <div class="list" v-for="(items, indexs) in item.topic_article_list"
                        :class="{ 'hot-box': indexs == 0, 'essence-box': indexs == 1 }" :key="indexs" @click="handleLink(items)">
                        <div class="t1s df jcsb aic over-h">
                            <div class="mic-semblod one-text">
                                <span class="essence" v-if="indexs == 0">{{ $t('精') }}</span>
                                <span class="hot" v-if="indexs == 1">{{ $t('热') }}</span>
                                {{ items.ttar_title }}
                            </div>
                            <div class="show-box fn">
                                <img v-if="indexs == 1" src="@/assets/images/hot.png" alt="">
                                <img v-if="indexs == 0" src="@/assets/images/essence.png" alt="">
                            </div>
                        </div>
                        <div class="desc tow-text" :title="items.ttar_desc">
                            {{ items.ttar_desc }}
                        </div>

                        <div class="userinfo-box df jcsb aic over-h">
                            <div class="users df aic f1 over-h">
                                <div @click="(event) => handleaAvatar(event, items)" class="df">
                                    <template v-if="items.ttar_type == 10">
                                        <el-avatar :size="18" :src="items.user_avatar_att_url" class="fn"
                                            @error="handleImageError">
                                            <img src="@/assets/images/avatar.png" alt="">
                                        </el-avatar>
                                    </template>
                                    <template v-else>
                                        <el-avatar :size="18" :src="require('@/assets/images/avatar.png')"
                                            class="fn"></el-avatar>
                                    </template>


                                </div>

                                <span class="name fn">
                                    {{
                                        items.is_expert == 10
                                            ? items.user_name
                                            : (items.ttar_type == 20 || items.user_id == 0 || items.user_nick_name === '' ||
                                                items.user_nick_name === null
                                                ? $t('匿名用户')
                                    : items.user_nick_name)
                                    }}
                                </span>

                                <div class="f1 type one-text" v-if="items.user_excel_arr.length">
                                    <span v-for="items1 in items.user_excel_arr">{{ items1.label }}</span>
                                </div>
                            </div>

                            <div class="dates df fn">
                                <div class="comment-list df">
                                    <div class="li">
                                        <span class="iconfont">&#xe611;</span>
                                        <span class="text">{{ items.ttar_hits }}</span>
                                    </div>
                                    <div class="li">
                                        <span class="iconfont">&#xe61b;</span>
                                        <span class="text">{{ items.ttar_likes }}</span>
                                    </div>
                                    <div class="li">
                                        <span class="iconfont">&#xe63e;</span>
                                        <span class="text">{{ items.reply_count }}</span>
                                    </div>
                                </div>
                                <span class="date">{{ items.create_time }}</span>
                            </div>
                        </div>

                    </div>

                    <div class="no-data pt-86" v-if="item.topic_article_list.length == 0">
                        <img src="@/assets/images/empty_data.png" alt="">
                        <p>{{ $t('暂无数据') }}</p>
                    </div>

                </div>
            </swiper-slide>

        </swiper>

        <div class="activity-btns">
            <div class="more-btn">
                <el-button type="primary" class="more" @click="handleMore('/subject/list')">{{
                    $t('查看更多') }}<span class="iconfont">&#xe7e2;</span></el-button>
                <div class="swiper-button-prev" id="topic_prev"></div>
                <div class="swiper-button-next" id="topic_next"></div>
            </div>
        </div>

        <!-- 发布文章 -->
        <articleModel ref="articleDialog" :tt_id="thumbsId" :classData="tablist"
            @post-submitted="handlePostSubmitted" />

        <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" @post-submitted="handleAvatarSubmitted" :id="id" />

    </div>
</template>

<script>
import { pathLoac } from "@config";
import { gettopicList } from "@api/home";
import { setArticleAdd } from "@api/active";
import { setuserfollowAdd,userDataLv2 } from "@api/home";
// 文章投稿
import articleModel from '@/components/articleModel.vue';
export default {
    components: { articleModel },
    data() {
        return {

            id: 0,

            swiperOption2: {
                slidesPerView: 'auto',
                normalizeSlideIndex: false,
                watchSlidesVisibility: true,/*避免出现bug*/
            },
            swiperOption3: {
                spaceBetween: 48,
                centeredSlides: true,
                centeredSlidesBounds: true,
                slidesPerView: 1.489,
                normalizeSlideIndex: false,
                navigation: {
                    nextEl: '#topic_next',
                    prevEl: '#topic_prev',
                },
                on: {
                    slideChange: this.onSlideChange2,
                },
            },

            thumbsindex: 0,
            thumbsId: 0,

            // 热门话题
            hotlist: [],

            tablist: [],

            allData: [],



            thisUserInfo:[],//当前登录人信息

        }
    },

    mounted() {
        this.getData();

    },
    methods: {

        // 跟多
        handleMore(path) {
          this.$navigate(path)
        },

        // 头像加载失败
        handleImageError() {
            return true;

        },

        handleaAvatar(event, item) {


            // 判断是否是实名用户
            if (item.ttar_type == 20 || item.user_id == 0 || item.user_nick_name == '' || item.user_nick_name == null) {
                return false;
            }
            event.stopPropagation(); // 阻止事件冒泡
            this.$refs.avatarDialog.openModal();
            this.id = item.user_id;

        },

        async handleAvatarSubmitted(id) {

            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);

            }

        },

        // 跳转详情
        handleLink(item) {
            // let str = "/protal";
            //
            // let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            // if (Language && Language != 'zh') {
            //     str = "/protal_" + Language;
            // }
            // const url = str + '/topicarticle/info/id/' + item.ttar_id; // 你想要跳转的 URL
            // window.open(url, '_blank');
          this.$navigate("/subject/info/" + item.ttar_id);
        },

        async handlePostSubmitted(content) {
            content.other_lang[0] = content.other_lang[0] ? 2 : 0;
            content.other_lang[1] = content.other_lang[1] ? 3 : 0;

            let res = await setArticleAdd(content);
            if (res.status == 200) {
                this.$message.success(res.msg);
            }
        },


        // 获取初始数据
        async getData() {
            let res = await gettopicList();

            if (res.status == 200) {
                this.tablist = res.data.topic_list.map((item) => {
                    return { tt_title: item.tt_title, tt_id: item.tt_id }
                })
                if (this.tablist.length > 0) {
                    this.thumbsId = this.tablist[0].tt_id;
                }
                this.allData = res.data.topic_list;
            }
        },

        // 热门话题切换
        onSlideClick(index) {

            // if (this.tablist.length == index + 1) {
            //     return false;
            // }
            const swiper1 = this.$refs.thumbsSwiper.$swiper;
            swiper1.slideTo(index);
            const topthumbsSwiper = this.$refs.topthumbsSwiper.$swiper;
            topthumbsSwiper.slideTo(index);

        },
        onSlideChange2() {

            this.thumbsindex = this.$refs.thumbsSwiper.$swiper.activeIndex;
            const topthumbsSwiper = this.$refs.topthumbsSwiper.$swiper;
            topthumbsSwiper.slideTo(this.thumbsindex);
            // this.thumbsId = this.tablist[this.thumbsindex].tt_id;
        },

        // 文章投稿
        async onArticle(id) {
            let checkRes=await userDataLv2();
            if(checkRes.status!=200){
                return false;
            }
            this.thumbsId = id;
            // 没有登录信息，跳转到登录
            this.thisUserInfo=JSON.parse(localStorage.getItem('userinfo'));
            if(!this.thisUserInfo || this.thisUserInfo.user_id===undefined || this.thisUserInfo.user_id<1){
                this.$jumpLogin();
                return false;
            }
            setTimeout(() => {
                this.$refs.articleDialog.openModal();
            }, 20);
        },


    }
}
</script>

<style lang="scss" scoped>
.swiper-container {
    padding-bottom: 38px;
    padding-left: 80px;
    padding-right: 80px;
}

.topic-title-box {
    height: 54px;
    padding-left: 80px;
    margin-bottom: 36px;

    .hot-title {
        color: rgb(25, 25, 25);
        font-size: 32px;
        font-weight: 400;
        line-height: 54px;
        margin-right: 40px;


    }

    .swiper-container {
        margin-left: 0;
        margin-right: 0;

    }

    .swiper-slide {
        width: auto;
        height: 54px;
        padding-top: 19px;
        padding-right: 52px;



        .active {
            color: #191919;
            font-size: 24px;
            font-family: "MicrosoftYaHeiSemibold";

            &::after {
                width: 28px;
            }

        }

        span {
            display: inline-block;
            color: rgb(89, 89, 89);
            font-size: 22px;
            font-weight: 400;
            line-height: 24px;
            cursor: pointer;
            position: relative;

            &:hover {
                color: #191919;
            }

            &::after {
                content: "";
                display: inline-block;
                width: 0px;
                height: 3px;
                border-radius: 4px;
                background: rgb(183, 37, 30);
                position: absolute;
                bottom: -8px;
                left: 50%;

                transition: all 0.36s;
                transform: translateX(-50%);
            }
        }
    }
}

.activity-btns {
    padding: 0 80px 80px;
    text-align: center;

    .more-btn {
        position: relative;
    }

    .swiper-button-prev,
    .swiper-button-next {
        top: auto;
        bottom: -4px;
        width: 43px;
        height: 43px;
        border-radius: 4px;
        background: rgb(243, 243, 243);
        transition: 'opacity' 0.36s, 'background' 0.36s;

        &:hover {
            background: #DD736D;

            &::after {
                color: #ffffff;
            }
        }
    }


    .swiper-button-prev.swiper-button-disabled,
    .swiper-button-next.swiper-button-disabled {
        opacity: 0;
    }

    .swiper-button-prev:after,
    .swiper-button-next:after {
        font-family: "iconfont";
        font-size: 7px;
        color: #959494;
    }

    .swiper-button-next:after {
        content: "\e605";
    }

    .swiper-button-prev:after {
        content: "\e606";
    }

    .more {
        min-width: 106px;
        height: 36px;
        font-size: 14px;
        color: rgb(25, 25, 25);
        background-color: #ffffff;
        box-sizing: border-box;
        border: 0.5px solid rgb(0, 0, 0);
        border-radius: 20px;
        padding: 0 16px;

        .iconfont {
            font-size: 12px;
            color: #191919;
            margin-left: 5px;
        }

        &:hover {
            border: 0.5px solid rgb(183, 37, 30);
            color: rgb(183, 37, 30);

            .iconfont {
                color: rgb(183, 37, 30);
            }
        }
    }
}

.left-cloud {
    position: absolute;
    width: 120px;
    height: 844px;
    background: linear-gradient(270.00deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.7) 100%);
    left: 0;
    top: 120px;
    z-index: 6;
}

.right-cloud {
    position: absolute;
    width: 131px;
    height: 844px;
    background: linear-gradient(270.00deg, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0) 100%);
    right: 0;
    top: 120px;
    z-index: 100;
}

.topic-list {
    position: relative;



    .swiper-slide {
        width: calc((100% - 80px) * 0.66);
        height: auto;
        padding: 24px;
        box-sizing: border-box;
        border-radius: 12px;
        box-shadow: 0px 16px 30px 0px rgba(0, 0, 0, 0.06);
        background: rgb(255, 255, 255);
        position: relative;
        top: 1px;



        &::after {
            content: '';
            position: absolute;
            top: -2px;
            left: -1px;
            right: -1px;
            bottom: -1px;
            background: linear-gradient(136deg, #D14A44, #fff);
            z-index: -1;
            border-radius: 14px;
            padding: 5px;
            box-sizing: border-box;
        }

        .t1 {
            width: 100%;
            height: 28px;
            position: relative;
            padding-left: 16px;

            span {
                color: rgb(25, 25, 25);

                font-size: 24px;
                font-weight: 400;
                line-height: 24px;
            }

            span::after {
                content: "";
                display: inline-block;
                width: 18px;
                height: 26px;
                border-radius: 0px 5px 5px 0px;
                background: linear-gradient(137.93deg, rgba(255, 204, 202, 0) -94.295%, rgb(222, 74, 67) 84.899%);
                position: absolute;
                left: -24px;
                top: 0;
            }

            button {
                min-width: 92.26px;
                height: 28px;
                box-sizing: border-box;
                border: none;
                border-radius: 20px;
                padding: 0 9px;
                letter-spacing: 1px;
                font-size: 14px;
                font-weight: 400;
            }
        }
    }

    .list-box {
        margin-top: 18px;


        .list {
            padding: 16px;
            border-bottom: 1px solid rgb(226, 226, 226);
            cursor: pointer;
            transition: border-bottom .36s;
            z-index: 10;

            &:hover {
                border-bottom: 1px solid #B7251E;

                .t1s {
                    color: #B7251E;
                }
            }

            &:last-child {
                border-bottom: none;

            }

            .t1s {
                color: rgb(25, 25, 25);
                font-size: 18px;
                font-weight: 400;
                line-height: 24px;
                padding: 2px 0;

                .essence,
                .hot {
                    display: inline-block;
                    min-width: 18px;
                    height: 18px;
                    border-radius: 2px;
                    font-size: 14px;
                    color: #ffffff;
                    line-height: 18px;
                    text-align: center;
                    margin-right: 4px;
                    position: relative;
                    padding: 0 2px;
                    top: -1px;
                }

                .essence {
                    background: rgb(215, 17, 17);
                }

                .hot {
                    background: rgb(255, 110, 0);
                }

                .show-box {
                    img {
                        margin-left: 6px;
                    }
                }
            }

            .desc {
                color: rgb(51, 51, 51);
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                height: 44px;
                margin-top: 10px;
            }
        }

        .hot-box,
        .essence-box {
            position: relative;

            &::after {
                content: "";
                display: block;
                width: 400px;
                height: calc(100% + 1px);
                opacity: 0.6;
                position: absolute;
                right: -24px;
                top: 0;

            }
        }

        .essence-box {
            &::after {
                background: linear-gradient(-64.32deg, rgba(254, 190, 8, 0.21) -2.449%, rgba(196, 196, 196, 0) 96.756%);
            }
        }

        .hot-box {
            &::after {
                background: linear-gradient(-64.32deg, rgba(255, 0, 0, 0.11) -2.446%, rgba(196, 196, 196, 0) 96.716%);
            }
        }

        .userinfo-box {
            height: 32px;
            margin-top: 8px;

            .name {
                font-size: 14px;
                margin-left: 6px;
            }
        }

        .type {
            height: 32px;
            position: relative;
            margin-left: 18px;
            padding: 5px 18px;

            &::after {
                content: "";
                display: block;
                height: 14px;
                width: 1px;
                background-color: #D8D8D8;
                position: absolute;
                top: 50%;
                margin-top: -7px;
                left: 0;
            }

            span {
                display: inline-block;
                height: 22px;
                background-color: #F0F1F1;
                border-radius: 4px;
                padding: 0 4px;
                color: #868D9F;
                line-height: 22px;
                font-size: 12px;
                margin-right: 6px;
            }
        }

        .dates {
            height: 32px;
            line-height: 32px;

            .date {
                font-size: 14px;
                color: #868D9F;
                position: relative;
                padding-left: 16px;

                &::after {
                    content: "";
                    display: inline-block;
                    height: 12px;
                    width: 1px;
                    background-color: #D8D8D8;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    margin-top: -6px;
                }
            }

            .comment-list {
                .li {
                    color: #868D9F;
                    font-size: 14px;
                    margin-right: 15px;

                    .iconfont {
                        margin-right: 5px;
                    }

                    .text {}
                }
            }
        }


    }
}
</style>